import branchCoffee from './images/branch-coffee.jpg'
export var coffeeMenu = [
  {
    imageSrc: "https://image2.tin247.com/pictures/2018/06/29/xov1530281002.jpg",
    title: "Cà phê đen",
    description: "",
    price: 9000
  },
  {
    imageSrc: "https://coffee.axys.asia/image/cache/catalog/foods/cf-suawx-1-700x700.jpg",
    title: "Cà phê sữa",
    description: "",
    price: 10000
  },
  {
    imageSrc: "https://scontent.smarttourism.vn/resources/portal//Images/SSN/halinh/menu/cafe_sai_gon_636909585714222092.jpg",
    title: "Cà phê đen SG",
    description: "Cà phê đen chất sài gòn",
    price: 14000
  },
  {
    imageSrc: "https://scontent.smarttourism.vn/resources/portal//Images/SSN/halinh/menu/cafe_sai_gon_636909585714222092.jpg",
    title: "Cà phê sủi bọt",
    description: "",
    price: 15000
  },
  {
    imageSrc: "https://file.alotrip.com/photo/alocafe/a-494.jpeg",
    title: "Cà phê sữa SG",
    description: "",
    price: 15000
  },
  {
    imageSrc: "https://cafecub.vn/wp-content/uploads/bacsiuda.png",
    title: "Bạc sỉu",
    description: "",
    price: 15000
  },
  {
    imageSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1gEOXUCsxSw6uvZ5qwYI6REy5bMnR2sd2sm1W2sd2ZTVz0Fhy&s",
    title: "Cà phê cốt dừa",
    description: "",
    price: 20000
  },
  {
    imageSrc: "https://znews-photo.zadn.vn/w660/Uploaded/jac_iik/2015_03_21/3.jpg",
    title: "Cà phê kem cục",
    description: "",
    price: 25000
  },

  {
    imageSrc: "https://qph.fs.quoracdn.net/main-qimg-83de370729a2c4321710df893756227c",
    title: "Americano",
    description: "",
    price: 12000
  },
  {
    imageSrc: "https://qph.fs.quoracdn.net/main-qimg-83de370729a2c4321710df893756227c",
    title: "Latte",
    description: "",
    price: 15000
  },
  {
    imageSrc: "https://znews-photo.zadn.vn/w660/Uploaded/jac_iik/2015_03_21/3.jpg",
    title: "Cà phê đen SG xay",
    description: "",
    price: 10000
  },


  {
    imageSrc: "https://product.hstatic.net/1000075078/product/chocolate_ice_blended_master.jpg",
    title: "Chocolate",
    description: "",
    price: 25000
  },
  {
    imageSrc: "https://www.brandsvietnam.com/upload/news/480px/2018/17219_Sua.jpg",
    title: "Sữa",
    description: "",
    price: 15000
  },
]

export var cakeMenu = [
  // {
  //   imageSrc: "http://afamilycdn.com/zoom/640_400/2019/2/28/10-1551357063892277652305-crop-15513572835471364870102.jpg",
  //   title: "Hoa quả chấm kiểu thái",
  //   description: "",
  //   price: 20000
  // },

  {
    imageSrc: "https://sieuthitt.com/images/stories/virtuemart/product/sua%20chua_vinamilk_nha%20dam.png",
    title: "Sữa chua hộp vinamilk",
    description: "",
    price: 10000
  },
  {
    imageSrc: "https://rockit.vn/wp-content/uploads/2018/09/Cach-lam-sua-chua-danh-da-cho-ngay-he-mat-ruoi-4.jpg",
    title: "Sữa chua đá",
    description: "",
    price: 15000
  },
  {
    imageSrc: "https://product.hstatic.net/1000298860/product/bac-siu_9909ec9e50b94b67a60250a379da41d5.jpg",
    title: "Sữa chua cacao",
    description: "",
    price: 19000
  },
  {
    imageSrc: "https://image-us.eva.vn/upload/2-2019/images/2019-05-03/cach-lam-sua-chua-hoa-qua-ngon-tai-nha-cach-lam-sua-chua-hoa-qua-3-1556854456-365-width551height366.jpg",
    title: "Sữa chua (đào / bạc hà / dâu / việt quất)",
    description: "",
    price: 19000
  },
  {
    imageSrc: "https://i.pinimg.com/originals/82/87/b2/8287b2ca5e5a325c013355d9e9db92c9.jpg",
    title: "Kem dâu (2 viên)",
    description: "",
    price: 24000
  },
  {
    imageSrc: "https://topchuan.com/wp-content/uploads/2019/10/unnamed-file-1993.jpg",
    title: "Kem dừa (2 viên)",
    description: "",
    price: 24000
  },
  {
    imageSrc: "https://cdn.dayphache.edu.vn/wp-content/uploads/2017/03/hoc-cach-lam-kem-socola.jpg",
    title: "Kem socola (2 viên)",
    description: "",
    price: 24000
  },
  {
    imageSrc: "https://cdn.huongnghiepaau.com/wp-content/uploads/2019/01/banh-flan-bang-sua-tuoi.jpg",
    title: "Kem flan nhà làm (1 bánh)",
    description: "",
    price: 10000
  },
  {
    imageSrc: "https://sohanews.sohacdn.com/thumb_w/660/2019/4/13/photo-7-15551247982371796812737-crop-15551249186881077357837.jpg",
    title: "Kem flan nhà làm (2 bánh)",
    description: "",
    price: 18000
  },
  // {
  //   imageSrc: "https://media.cooky.vn/recipe/g5/46800/s800x500/cooky-recipe-cover-r46800.jpg",
  //   title: "Hoa quả dầm sữa/yogurt",
  //   description: "",
  //   price: 20000
  // },
  {
    imageSrc: "https://media.ex-cdn.com/EXP/media.phunutoday.vn/files/thanh.le/2017/04/28/huong-duong-0947-phunutoday.jpg",
    title: "Hạt hướng dương",
    description: "",
    price: 10000
  },
  {
    imageSrc: "http://hatdinhduongonline.com/wp-content/uploads/2019/04/Dinh-d%C6%B0%E1%BB%A1ng-trong-h%E1%BA%A1t-d%C6%B0a-l%C3%A0-g%C3%AC.jpg",
    title: "Hạt dưa",
    description: "",
    price: 10000
  },
  {
    imageSrc: "https://cdn.24h.com.vn/upload/1-2018/images/2018-02-03/1517626592-966-moi-lan-ve-nha-van-thanh-chi-muon-duoc-bo-me-nau-cho-mon-an-cuc-don-gian-nay-0-1517623610-width498height384.jpg",
    title: "Mì tôm trứng",
    description: "",
    price: 15000
  },
  {
    imageSrc: "http://phanthiet.ttchotels.com/uploads/images/hotel-ttc-hotel-premium-phan-thiet/images/banh-trang-cham-mam-ruoc.jpg",
    title: "Bánh tráng ruốc",
    description: "",
    price: 15000
  },
  {
    imageSrc: "http://afamilycdn.com/2017/batch-mg-3208-1500304177070.jpg",
    title: "Bò khô chanh",
    description: "",
    price: 15000
  },
]

export var milkMenu = [
  {
    imageSrc: "https://phobanh.net/wp-content/uploads/2019/08/milo-dam-tran-chau.jpg",
    title: "Milo dầm kèm bánh",
    description: "",
    price: 20000
  },
  {
    imageSrc: "https://xmedia.nguoiduatin.vn/thumb_x600x600/2017/5/4/9747/sinh-to-sua-dua-1493890684.jpg",
    title: "Sữa dừa non xay",
    description: "",
    price: 19000
  },
  {
    imageSrc: "https://product.hstatic.net/1000075078/product/chocolate_ice_blended_master.jpg",
    title: "Chocolate",
    description: "",
    price: 15000
  },
  {
    imageSrc: "https://www.brandsvietnam.com/upload/news/480px/2018/17219_Sua.jpg",
    title: "Sữa nóng/đá",
    description: "",
    price: 12000
  },
  {
    imageSrc: "https://www.brandsvietnam.com/upload/news/480px/2018/17219_Sua.jpg",
    title: "Sữa tươi cafe/cacao",
    description: "",
    price: 17000
  },
  {
    imageSrc: "https://nutifood.com.vn/sua-trai-cay/assets/img/landing/product.png",
    title: "Sữa Nutri boost / Trà xanh",
    description: "",
    price: 12000
  },
  {
    imageSrc: "https://cf.shopee.vn/file/bc57603af6fa41bb3f1ad514489a7a83",
    title: "Khoáng sữa / bò húc",
    description: "",
    price: 12000
  },
  {
    imageSrc: "https://cf.shopee.vn/file/2dea2f8301175989b48e9bd59c75e1e1",
    title: "Nước khoáng/ Nước suối chai/ Sữa vinamilk/ 7Up/ Sting/ Pepsi",
    description: "",
    price: 10000
  },
]

export var juiceMenu = [
  {
    imageSrc: branchCoffee,
    title: "Sinh tố trái cây xay nhuyễn",
    description: "",
    price: 24000
  },
  {
    imageSrc: branchCoffee,
    title: "Sữa chua chanh dây",
    description: "",
    price: 19000
  },
  {
    imageSrc: branchCoffee,
    title: "Sữa chua dâu",
    description: "",
    price: 19000
  },
  {
    imageSrc: branchCoffee,
    title: "Sữa chua bạc hà",
    description: "",
    price: 19000
  },
  {
    imageSrc: branchCoffee,
    title: "Sữa chua đào",
    description: "",
    price: 19000
  },
  {
    imageSrc: branchCoffee,
    title: "Sữa chua hộp vinamilk",
    description: "",
    price: 10000
  },
  {
    imageSrc: branchCoffee,
    title: "Sữa chua đá",
    description: "",
    price: 13000
  },
]

export var teaMenu = [
  {
    imageSrc: branchCoffee,
    title: "Trà Hoa Hồng",
    description: "",
    price: 30000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà Cung Đình",
    description: "",
    price: 33000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà Bắc Ấm",
    description: "",
    price: 33000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà dưỡng nhan thanh lọc",
    description: "",
    price: 35000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà hồng sâm bát tiên",
    description: "",
    price: 35000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà hoa nhài",
    description: "",
    price: 30000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà hoa cúc",
    description: "",
    price: 30000
  },
  {
    imageSrc: branchCoffee,
    title: "Chanh xí muội",
    description: "",
    price: 20000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà sữa Hàn Quốc MACHI",
    description: "",
    price: 25000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà sữa chanh dây",
    description: "",
    price: 18000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà sữa bạc hà",
    description: "",
    price: 19000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà sữa việt quất",
    description: "",
    price: 33000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà sữa dâu",
    description: "",
    price: 19000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà sữa đào",
    description: "",
    price: 19000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà lipton chanh",
    description: "",
    price: 33000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà đào sả tắc",
    description: "",
    price: 33000
  },
  {
    imageSrc: branchCoffee,
    title: "Soda đào",
    description: "",
    price: 33000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà tắc xí muội",
    description: "",
    price: 25000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà gừng xí muội",
    description: "",
    price: 17000
  },
  {
    imageSrc: branchCoffee,
    title: "Soda dâu",
    description: "",
    price: 33000
  },
  {
    imageSrc: branchCoffee,
    title: "Soda việt quất",
    description: "",
    price: 33000
  },
  {
    imageSrc: branchCoffee,
    title: "Soda bạc hà",
    description: "",
    price: 20000
  },
  {
    imageSrc: branchCoffee,
    title: "Nước chanh dây",
    description: "",
    price: 20000
  },
  {
    imageSrc: branchCoffee,
    title: "Nước cà chua",
    description: "",
    price: 22000
  },
  {
    imageSrc: branchCoffee,
    title: "Nước táo",
    description: "",
    price: 22000
  },
  {
    imageSrc: branchCoffee,
    title: "Nước thơm",
    description: "",
    price: 22000
  },
  {
    imageSrc: branchCoffee,
    title: "Nước cà rốt",
    description: "",
    price: 22000
  },
  {
    imageSrc: branchCoffee,
    title: "Nước cam",
    description: "",
    price: 25000
  },
  {
    imageSrc: branchCoffee,
    title: "Nước suối chai",
    description: "",
    price: 10000
  },
  {
    imageSrc: branchCoffee,
    title: "Nước khoáng",
    description: "",
    price: 12000
  },
  {
    imageSrc: branchCoffee,
    title: "Bò húc",
    description: "",
    price: 15000
  },
  {
    imageSrc: branchCoffee,
    title: "Trà xanh",
    description: "",
    price: 13000
  },
  {
    imageSrc: branchCoffee,
    title: "Nutri boost",
    description: "",
    price: 13000
  },
  {
    imageSrc: branchCoffee,
    title: "Cacao",
    description: "",
    price: 18000
  },
]

export var hostelRooms = {
  superior: [
    {
      image: 'https://a0.muscache.com/im/pictures/50019353-a6fe-47cd-bdb4-ceeb02844933.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/e55f1221-c412-4108-ad0c-988da75e869e.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/39626440-ac72-4332-a8e9-73bed1c012a9.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/e811eca0-3fea-4a89-a3be-89a8be7faae1.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/31b2d5c0-9f04-4a65-840d-3700f82a8250.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/fe8cc1b7-af93-4d1c-ab3b-24a1eb1257f9.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/e8fe3107-b399-49a7-87d6-c4e07f65cf0b.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/859ffd96-151b-4b2b-b15c-5bc36f6338df.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/0ea5497e-a05f-406d-9065-759746bf522e.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/131455b0-6c8e-430e-a998-9cebb7450973.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/e910fe3c-96a7-487c-89d8-03a4315eaa0c.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/03c928b6-fed9-4578-a51a-8bca9e5c1543.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/82cbe314-2c4c-40fa-8f05-f701a08db269.jpg?aki_policy=xx_large'
    },
  ],
  double: [
    {
      image: 'https://a0.muscache.com/im/pictures/859ffd96-151b-4b2b-b15c-5bc36f6338df.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/50019353-a6fe-47cd-bdb4-ceeb02844933.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/e55f1221-c412-4108-ad0c-988da75e869e.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/39626440-ac72-4332-a8e9-73bed1c012a9.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/e811eca0-3fea-4a89-a3be-89a8be7faae1.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/31b2d5c0-9f04-4a65-840d-3700f82a8250.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/fe8cc1b7-af93-4d1c-ab3b-24a1eb1257f9.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/e8fe3107-b399-49a7-87d6-c4e07f65cf0b.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/0ea5497e-a05f-406d-9065-759746bf522e.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/131455b0-6c8e-430e-a998-9cebb7450973.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/82cbe314-2c4c-40fa-8f05-f701a08db269.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/e910fe3c-96a7-487c-89d8-03a4315eaa0c.jpg?aki_policy=xx_large'
    },
    {
      image: 'https://a0.muscache.com/im/pictures/03c928b6-fed9-4578-a51a-8bca9e5c1543.jpg?aki_policy=xx_large'
    },
  ],
  dorm: [
    {
      image: 'https://r-cf.bstatic.com/images/hotel/max1024x768/240/240231242.jpg'
    },
    {
      image: 'https://q-cf.bstatic.com/images/hotel/max1024x768/240/240231249.jpg'
    },
    {
      image: 'https://r-cf.bstatic.com/images/hotel/max1024x768/240/240231259.jpg'
    },
    {
      image: 'https://q-cf.bstatic.com/images/hotel/max1024x768/240/240231253.jpg'
    },
    {
      image: 'https://r-cf.bstatic.com/images/hotel/max1024x768/240/240231218.jpg'
    },
    {
      image: 'https://q-cf.bstatic.com/images/hotel/max1024x768/240/240228815.jpg'
    },
    {
      image: 'https://r-cf.bstatic.com/images/hotel/max1024x768/240/240874954.jpg'
    },
    {
      image: 'https://q-cf.bstatic.com/images/hotel/max1024x768/240/240874950.jpg'
    },
    {
      image: 'https://r-cf.bstatic.com/images/hotel/max1024x768/240/240228831.jpg'
    },
  ]
}
